import {
  FETCH_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE,
  RESET_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE,
} from "../../constants/action.constants";
const initialState = {
  list: [],
  //   others: {
  //     total: 0,
  //     offset: 0,
  //     limit: 10,
  //   },
};

const planogramListByVMTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE:
      return {
        list: action.payload,
        // , others: action.others
      };
    case RESET_PLANOGRAM_TEMPLATE_LIST_BY_VM_TEMPLATE:
      return initialState;
    default:
      return state;
  }
};

export default planogramListByVMTemplateReducer;
